import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import SideBar from "../Layout/SideBar/SideBar";
import { useAppDispatch } from "../../app/hooks";
import { createNewFolder } from "../../app/promptsSlice";
import { openPromptPackagesModal } from "../../app/promptsSlice";

function LibraryPanel() {
  const dispatch = useAppDispatch();

  const handleNewFolder = () => {
    dispatch(createNewFolder());
  };

  const handleOpenPackagesModal = () => {
    dispatch(openPromptPackagesModal());
  };

  return (
    <Box
      sx={{
        height: `calc(100vh - 64px)`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <List sx={{ p: 0 }}>
        <ListItem
          disablePadding
          sx={{
            borderBottom: "1px solid #464646",
          }}
        >
          <ListItemButton
            onClick={handleOpenPackagesModal}
            sx={{ justifyContent: "center" }}
          >
            <ListItemIcon sx={{ justifyContent: "center" }}>
              <CloudDownloadIcon />
            </ListItemIcon>
          </ListItemButton>
          <ListItemButton
            onClick={handleNewFolder}
            sx={{ justifyContent: "center", borderLeft: "1px solid #464646" }}
          >
            <ListItemIcon sx={{ justifyContent: "center" }}>
              <CreateNewFolderIcon />
            </ListItemIcon>
          </ListItemButton>
          <ListItemButton
            component={RouterLink}
            to={"/new"}
            sx={{ justifyContent: "center", borderLeft: "1px solid #464646" }}
          >
            <ListItemIcon sx={{ justifyContent: "center" }}>
              <NoteAddIcon />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      </List>
      <SideBar />
    </Box>
  );
}

export default LibraryPanel;
